<script lang="ts">
    import FileUpload from "$lib/components/FileUpload.svelte";
    import {getBaseUrl} from "$lib/baseUrlResolver";
    import {diffState, type DiffState} from "$lib/stores/masterdataStore";
    import ErrorMessage from "$lib/components/ErrorMessage.svelte";
    import MasterdataDiffView from "$lib/components/MasterdataDiffView.svelte";
    import {errorDetails, type ErrorState, errorState} from "$lib/stores/errorState";

    let {props}: { props: Record<string, string | undefined> } = $props()

  let masterdataState: DiffState = $state('Idle');
  diffState.subscribe(value => {
    masterdataState = value;
  });

  let error: Error | unknown | null = $state(null);
  errorDetails.subscribe(value => {
    error = value;
  });

  let errorStateValue: ErrorState = $state("OK");
  errorState.subscribe(value => {
    errorStateValue = value;
  });

  let originatingEnv = props['data-originating-env'] ?? ''

  const absoluteExcelImg = `${getBaseUrl()}/images/xls_example.png`
</script>
<div class="scroll-auto">
    <h2>Edit installations</h2>
    {#if masterdataState === 'Idle'}
      <FileUpload originatingEnv={originatingEnv}/>
    {/if}
    {#if masterdataState === 'Loading'}
      <div class="card">
        Uploading file, please wait...
      </div>
    {/if}
    {#if masterdataState === 'Ready' || masterdataState === 'Applied'}
      <MasterdataDiffView
          originatingEnv={originatingEnv}
      />
    {/if}
    {#if errorStateValue === 'Error'}
      <ErrorMessage error={error}/>
    {/if}
    <img class="mt-1" src={absoluteExcelImg} alt="Example Import installations excel file"/>
</div>
